import { Link } from "react-router-dom";

// *-card.webp: the old CSS grade (brightness .95 / contrast 1.05 / saturate .7)
// is baked into these files - a live filter on a photo mid scale-transition
// cost 80-180ms frames in Firefox (Firefox audit, 2026-09-19).
const IMG_BY_SLUG = {
  "ultimate-lap": "/photos/hero-ul-6-yas-supra-23-pan-card.webp",
  "speed-gates": "/photos/card-speed-gates-v3-client.webp", // Supra #19 + Evo #24 at the cones, night paddock (client's own file AS500873, 2000x1125, untouched - 2026-10-10)
  "track-days": "/photos/card-track-days-v2-card.webp", // blue M4 under lights
  "corporate-events": "/photos/card-corporate-events-v3-card.webp", // DSC01086: Dubai Autodrome group under the 20-years gantry (client, 2026-10-07)
};
const FALLBACK_IMG = "/photos/card-track-days-v2-card.webp";

// Portfolio hierarchy (client directive):
//   row 1: Ultimate Lap        — big
//   row 2: Speed Gates | Track Days — two small cards side by side (coming soon)
//   row 3: Corporate Events    — big
const LAYOUT = [
  { slugs: ["ultimate-lap"], size: "lg" },
  { slugs: ["speed-gates", "track-days"], size: "sm" },
  { slugs: ["corporate-events"], size: "lg" },
];

function EventCard({ e, size }) {
  const soon = e.status === "coming-soon";
  const img = IMG_BY_SLUG[e.slug] || FALLBACK_IMG;
  // Series in planning have a microsite with a Register-interest form (client, 2026-09-09).
  const cta = soon ? "Register interest" : "Enter the series";
  return (
    <Link
      to={`/events/${e.slug}`}
      className={`gm-event gm-event--${size} ${soon ? "is-soon" : ""}`}
      data-testid={`event-card-${e.slug}`}
      data-size={size}
    >
      <div className="gm-event__media img-mask" data-reveal="img">
        <img
          src={img}
          alt=""
          loading="eager"
          fetchPriority="low"
          decoding="async"
          onError={(ev) => (ev.currentTarget.style.display = "none")}
        />
      </div>

      <div className="gm-event__body">
        <div className="gm-event__lockup">
          <img src={e.lockup} alt={e.name} width={480} height={480} loading="lazy" decoding="async" />
        </div>
        <div className="gm-event__meta">
          <div className="gm-event__eyebrow" data-testid={`event-subtitle-${e.slug}`}>{e.subtitle}</div>
          <h3 className="display-md gm-event__title">{e.name}</h3>
        </div>
        <div className="gm-event__foot">
          <span className="btn btn--pill btn--dark gm-event__pill" data-testid={`event-cta-${e.slug}`}>
            {cta}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function EventsPortfolio({ events }) {
  const bySlug = Object.fromEntries((events || []).map((e) => [e.slug, e]));
  return (
    <section className="gm-events" data-testid="events-section" id="events">
      <div className="container-gm">
        <div className="gm-events__header">
          {/* Client, 2026-10-10: heading is just "FOUR DISCIPLINES" - no full stop. */}
          <h2 className="display-md" data-reveal="mask">
            FOUR DISCIPLINES
          </h2>
        </div>

        <div className="gm-events__list">
          {LAYOUT.map((row) => {
            const items = row.slugs.map((s) => bySlug[s]).filter(Boolean);
            if (!items.length) return null;
            return (
              <div className={`gm-events__row gm-events__row--${row.size}`} key={row.slugs.join("+")}>
                {items.map((e) => <EventCard e={e} size={row.size} key={e.slug} />)}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
